import type { AdminHomeLink, FeatureRoute, SlotContribution } from '@/shared/registry'

import { userFormTabsSlot } from '../users/user'
import { createUserGroupPath, editUserGroupRoute, readUserGroupsPermission, userGroupRoute, userGroupsPath, writeUserGroupsPermission } from './paths'

export { UserGroupChooser, type ChosenUserGroup, type UserGroupChooserProps } from './UserGroupChooser'
export { readUserGroupsPermission, userGroupPath } from './paths'
export { useMemberGroups, type MemberGroup, type MemberGroups } from './use-member-groups'

/** Find User Groups, Group Details, and Create and Edit Group (SM-23). */
export const userGroupRoutes: readonly FeatureRoute[] = [
  {
    path: userGroupsPath,
    titleId: 'siteManagement.userGroups.find.title',
    page: () => import('./FindUserGroupsPage').then((module) => module.FindUserGroupsPage),
  },
  {
    path: createUserGroupPath,
    titleId: 'siteManagement.userGroups.create.title',
    page: () => import('./UserGroupFormPages').then((module) => module.CreateUserGroupPage),
  },
  {
    path: userGroupRoute,
    titleId: 'siteManagement.userGroups.details.title',
    page: () => import('./UserGroupDetailsPage').then((module) => module.UserGroupDetailsPage),
  },
  {
    path: editUserGroupRoute,
    titleId: 'siteManagement.userGroups.edit.title',
    page: () => import('./UserGroupFormPages').then((module) => module.EditUserGroupPage),
  },
]

/** Find and Create User Group on Admin Home, under User Groups. */
export const userGroupAdminHomeLinks: readonly AdminHomeLink[] = [
  { id: 'find-user-groups', category: 'user-groups', labelId: 'siteManagement.userGroups.find.title', path: userGroupsPath, permission: readUserGroupsPermission },
  { id: 'create-user-group', category: 'user-groups', labelId: 'siteManagement.userGroups.create.title', path: createUserGroupPath, permission: writeUserGroupsPermission },
]

/** The Groups tab on Create and Edit User, saved with the form. */
export const userGroupSlots: readonly SlotContribution[] = [
  {
    kind: 'tab',
    slot: userFormTabsSlot,
    id: 'user-groups',
    labelId: 'siteManagement.userGroups.userTab.label',
    component: () => import('./UserGroupsFormTab').then((module) => module.UserGroupsFormTab),
  },
]
